module.exports = __webpack_public_path__ + "static/media/user-level-icon.ee79e676.svg";